import type { QueryBudgetEstimate } from "../types";

interface QueryBudgetNoticeProps {
    estimate?: QueryBudgetEstimate | null;
    error?: Error | null;
}

export function QueryBudgetNotice({ estimate, error }: QueryBudgetNoticeProps) {
    if (!estimate && !error) return null;

    return (
        <div
            role="alert"
            style={{
                padding: "16px 20px",
                border: "1px solid rgb(var(--colour-semantic-caution, 245, 166, 35))",
                borderRadius: 8,
                background: "rgba(var(--colour-semantic-caution, 245, 166, 35), 0.08)",
            }}
        >
            <strong>{estimate ? "This selection is too large to load." : "Could not estimate selection"}</strong>
            <p style={{ margin: "6px 0 0" }}>
                {estimate
                    ? "Choose fewer countries or a shorter period."
                    : (error?.message ?? "Try changing the selection.")}
            </p>
        </div>
    );
}
